// Auto-generated entry for staticcontent// import './../../staticcontent.scss';

// Includes general styles and scripts
import './initial';

import TKModuleFactory from '@tk/utilities/tk.module.factory';
import TKFileUploadArea from '@tk/controls/tk.file.upload.area';

export default class Staticcontent extends TKModuleFactory {
    constructor() {
        super([{ name: 'tk-file-upload-area', constructor: TKFileUploadArea }]);
    }
}

new Staticcontent();
